import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { setNavigationKey } from '../redux/action/navigation/NavigationActions';
import {
  MENU_ITEMS,
  USER_ROLE
} from '../components/navigation/NavigationBarConstants';
import * as _ from 'lodash';

class RedirectPage extends Component {
  componentDidMount() {
    const menuItems = MENU_ITEMS.filter((item) => {
      if (_.includes(item.role, this.props.userInfo.roles[0])) {
        if (
          !_.isEmpty(item.permissionKey) &&
          this.props.userInfo.roles[0] === USER_ROLE
        ) {
          return !_.isEmpty(
            item.permissionKey.filter(
              (i) => this.props.userInfo.userPermissions[i]
            )
          );
        } else {
          return true;
        }
      } else {
        return false;
      }
    });

    if (!_.isEmpty(menuItems)) {
      Promise.resolve(this.props.setNavigationKey(menuItems[0].key)).then(
        () => {
          this.props.history.push(menuItems[0].path);
        }
      );
    } else {
      this.props.history.push('/403');
    }
  }

  render() {
    return <></>;
  }
}

function mapStateToProps({ auth, navigationStore }) {
  return {
    userInfo: auth.userInfo,
    currentKey: navigationStore.currentKey
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setNavigationKey: bindActionCreators(setNavigationKey, dispatch)
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(RedirectPage)
);
